//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import { LIST_COLORS } from "@/constants/ui.js";
import { intToHumanReadable } from "@/utils/converter.js";
import { datesToHuman } from "@/utils/dates.js";
import typo from "ru-typo";
import debounce from "lodash/debounce.js"
import { v4 as uuidv4 } from 'uuid';
import { DesignExtra } from "@/utils/dto/objects.js";
import { adjustColorBrightness } from "@/utils/helpers.js";
import factsEntranceAnimation from "@/mixins/factsEntranceAnimation.js";

export default {
  name: "Minimalism",
  components: { IconView },
  mixins: [factsEntranceAnimation],
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    objectLabel: {
      type: String,
      required: false,
      default: () => {}
    },
    design: {
      type: String,
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => {}
    },
    template: {
      type: Object,
    },
    theme: {
      type: String,
    },
    listInfo: {
      type: Object
    },
    user: {
      type: Object,
      default: () => {}
    },
  },

  data() {
    return {
      colors: [...LIST_COLORS],
    }
  },

  computed: {
    siTypes() {
      return (this.$store.state.property_templates.consts.si ?? [])
    },
    coloredItems() {
      let insertIndex = 0

      const items = this.items.map((fact, index) => {
        const item = JSON.parse(JSON.stringify(fact))
        item.id = `${fact.id}_${index}`
        item.color = this.getBlockBorderColor(index + 1)
        item.iconBg = this.getIconBg(index)
        item.iconBorderColor = this.getIconBorderColor(index)
        item.iconColor = this.getIconColor
        item.humanReadableValue = this.buildHumanReadable(fact.value)
        item.description = typo(fact.description, { hyphens: true })
        return item
      })

      // if (!this.isSmall && items.length % 2 !== 0) {
      items.splice(insertIndex, 0, {
        id: uuidv4(),
        humanReadableValue: {
          val: [this.label]
        },
        color: this.getBlockBorderColor(insertIndex),
        iconBg: this.getIconBg(insertIndex),
        iconBorderColor: this.getIconBorderColor(insertIndex),
        iconColor: this.getIconColor,
        value: {
          type: 'label'
        }
      })

      return items
    },
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    blockBorderPalette() {
      if (this.design_extra?.block_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.block_border.palette)[0];
      }

      return null;
    },
    iconBorderPalette() {
      if (this.design_extra?.icon_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_border.palette)[0];
      }

      return null;
    },
    iconBgPalette() {
      if (this.design_extra?.icon_bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_bg.palette)[0];
      }

      return null;
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? '#212121' ?? null;
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? '#212121' ?? null;
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color ?? 'black';
    },
    getIconGradientEnabled() {
      return this.design_extra?.icon_bg?.gradient_enabled ?? null;
    },
    getIconGradientDirection() {
      return this.design_extra?.icon_bg?.gradient_direction ?? null;
    },
    getIconGradientShadowDirection() {
      return this.design_extra?.icon_bg?.gradient_shadow_direction ?? null;
    },
  },
  methods: {
    getDate([from, to]) {
      if (!from && !to) {
        return ''
      }
      if (!to) {
        return `${from[0] || ''} ${from[1] || ''}`
      } else {
        return `${from[0] || ''} ${from[1] || ''} - ${to[0] || ''} ${to[1] || ''}`
      }
    },
    getBlockBorderColor(index) {
      if (this.blockBorderPalette) {
        return [this.blockBorderPalette.main_color, ...this.blockBorderPalette.colors][index % [this.blockBorderPalette.main_color, ...this.blockBorderPalette.colors].length];
      } else if (this.design_extra?.block_border?.color) {
        return this.design_extra.block_border.color
      }

      return null;
    },
    getIconBorderColor(index) {
      if (this.iconBorderPalette) {
        return [this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors][index % [this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors].length];
      } else if (this.design_extra?.icon_border?.color) {
        return this.design_extra.icon_border.color
      }

      return null;
    },
    getIconBg(index) {
      if (this.getIconGradientEnabled) {
        if (this.iconBgPalette) {
          const color = [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        } else if (this.design_extra?.icon_bg?.color) {
          const color = this.design_extra.icon_bg.color;
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        }
      } else {
        if (this.iconBgPalette) {
          return [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
        } else if (this.design_extra?.icon_bg?.color) {
          return this.design_extra.icon_bg.color
        }
      }

      return null;
    },
    buildHumanReadable(value) {
      switch (value.type) {
      case "number":
        const si = value.si ? this.siTypes.find(x => x.id === value.si) : null
        const numberVal = [intToHumanReadable(value.data), si ? si : null]
        return { val: numberVal }
      case "date":
        const dateVal = datesToHuman({ value: value.data.vfrom?.value || value.data.vfrom }, { value: value.data.vto?.value || value.data.vto }, 'object')
        return { val: dateVal }
      default:
        return { val: [value.data] }
      }
    },
  }
}
